module.exports = __webpack_public_path__ + "img/rocketship-2.491bc52c.webp";